import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
    historicData: [],
    marketCap : [],
    searchTicker : {},
    favourites : [],
    bonds : []
}

const name = 'analysis'
const parentSelector = state => state?.[name]

const analysisSlice = createSlice({
    name: name,
    initialState: initialState,
    reducers: {
        setHistoricData: (state, action) => {
             return {
                ...state,
                historicData: action.payload,
            };
        },
        setMarketCap: (state, action) => {
             return {
                ...state,
                marketCap: action.payload,
            };
        },
        setSearchTicker: (state, action) => {
             return {
                ...state,
                 searchTicker: action.payload,
            };
        },
        setFavourites: (state, action) => {
             return {
                ...state,
                 favourites: action.payload,
            };
        },
        setBonds: (state, action) => {
             return {
                ...state,
                 bonds: action.payload,
            };
        }
    }
});


const getHistoricData = createSelector(parentSelector, state => {
     return state?.historicData
})
const getMarketCap = createSelector(parentSelector, state => {
    return state?.marketCap
})
const getsearchTicker = createSelector(parentSelector, state => {
    return state?.searchTicker
})
const getFavourites = createSelector(parentSelector, state => {
    return state?.favourites
})
const getBonds = createSelector(parentSelector, state => {
    return state?.bonds
})
 

const actions = {
    ...analysisSlice.actions
}

const selectors = {
    getHistoricData,
    getMarketCap,
    getsearchTicker,
    getFavourites,
    getBonds
}

export const analysisActions = { actions, selectors }


export default analysisSlice;